<template>
  <material-card class="entity-history">
    <v-layout slot="header" px-3 align-content-center>
      <v-flex mt-2 pl-3 align-center justify-center>
        <div class="headline">Historia</div>

        <p>Historia punktów w kontenerze</p>
      </v-flex>
    </v-layout>

    <material-table :headers="tableHeaders" :items="list" :total-count="count" />
  </material-card>
</template>

<script>
import MaterialCard from '@/components/material/Card';
import MaterialTable from '@/components/material/Table';
import { mapState } from 'vuex';
import moment from 'moment';

// @vuese
// Historia punktów kontera
// @group containers
export default {
  components: { MaterialCard, MaterialTable },
  data() {
    return {
      tableHeaders: [
        { value: 'id', text: 'ID', sortable: true },
        {
          value: 'created',
          text: 'Data',
          sortable: true,
          orderBy: 'created',
          render: item => moment(item.created).format('YYYY-MM-DD HH:mm')
        },
        { value: 'benefit', text: 'Usługa', sortable: false, render: item => item.benefit.name },
        {
          value: 'profile',
          text: 'Użytkownik',
          sortable: false,
          render: item => `${item.profile.firstName} ${item.profile.lastName}`
        },
        { value: 'points', text: 'Punkty', sortable: false }
      ]
    };
  },

  computed: {
    ...mapState({
      list: state => state.pointHistory.list,
      count: state => state.pointHistory.count
    })
  }
};
</script>
